
import AuthUtils from "../../AuthUtils";

export const AuthChallengeConstants = {
	"ACTION_NIL" : 0,
	"DISCARD_TOKEN" : 1,
	"UNKNOWN" : 2,
	"REASON_MISSING" : 3,
	"DESTROY_TOKEN_FAMILY": 4
}

export class AuthChallenge{
	private realm: string;
	private reqtokentemplate: string;
	private reason: string;
	private locations: string;
	private servicerootHint: string;

	constructor(challenge: any){
		this.realm = challenge['realm'];
		this.reqtokentemplate = challenge['reqtokentemplate'];
		this.reason = challenge['reason'];
		this.locations = challenge['locations'];
		this.servicerootHint = challenge['serviceroot-hint'];
	}

	challengeType(): number {
        if(this.reason) {
            switch(this.reason){
				case "notoken":
				case "notforthisservice":
					return AuthChallengeConstants.ACTION_NIL;
				case "expired":
				case "nottrusted":
				case "decryptfailed":
				case "invalidtoken":
				case "invalidAudience":
				case "signatureinvalid":
				case "tokenSignatureNotVerified":
					return AuthChallengeConstants.DISCARD_TOKEN;
				case "badaccount":
				case "badpassword":
				case "wrongclaims":
				case "passwordClaimNotFound":
				case "gatewayclaimsinconsistent":
					return AuthChallengeConstants.DESTROY_TOKEN_FAMILY;
				default:
					return AuthChallengeConstants.UNKNOWN;
            }
		}
		return AuthChallengeConstants.REASON_MISSING;
	}

	getReason(): string{
		return this.reason;
	}
	
	getRealm(): string{
        return this.realm;
    }

    getLocations(): string{
        return this.locations;
	}
	
	getServicerootHint(): string{
		return this.servicerootHint;
	}

	getRequestTokenTemplate(): string{
		return this.reqtokentemplate;
	}
	
	getAuthDomain(): string{
		return AuthUtils.getInstance().getAuthDomainFromRealm(this.realm);
	}
}